export const operationTypes = [
  { SIMPLE: 'SIMPLE' },
  { EXTENDED: 'EXTENDED' },
];

// id роли Суперадмина в базе
// т.к. у нас разные среды, то Роли суперадмина в разных средах могут иметь разные ID.
// для корректного тестирования их (Id суперадминов) надо тут все перечислить
// TODO - Добавить ID суперадминов из других сред. 03.04.2020, КУзнецов Г.Л.
export const ROLE_SUPER_ADMIN = ['e06f1240-b72e-4d7c-aa56-65a4f2335bbd', // dev
  '1775cf74-5eb5-4517-a352-9ee6935b5be2']; // Prod, test, test-release

export const RESET_ERROR = 'permissions/RESET_ERROR';

export const FETCH_ROLES_SUCCESS = 'permissions/FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAIL = 'permissions/FETCH_ROLES_FAIL';
export const CREATE_ROLE_SUCCESS = 'permissions/CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = 'permissions/CREATE_ROLE_FAIL';
export const UPDATE_ROLE_SUCCESS = 'permissions/UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAIL = 'permissions/UPDATE_ROLE_FAIL';
export const DELETE_ROLE_SUCCESS = 'permissions/DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAIL = 'permissions/DELETE_ROLE_FAIL';

export const FETCH_SERVICES_SUCCESS = 'permissions/FETCH_SERVICES_SUCCESS';
export const FETCH_SERVICES_FAIL = 'permissions/FETCH_SERVICES_FAIL';
export const CREATE_SERVICE_SUCCESS = 'permissions/CREATE_SERVICE_SUCCESS';
export const CREATE_SERVICE_FAIL = 'permissions/CREATE_SERVICE_FAIL';
export const UPDATE_SERVICE_SUCCESS = 'permissions/UPDATE_SERVICE_SUCCESS';
export const UPDATE_SERVICE_FAIL = 'permissions/UPDATE_SERVICE_FAIL';
export const DELETE_SERVICE_SUCCESS = 'permissions/DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAIL = 'permissions/DELETE_SERVICE_FAIL';

export const FETCH_SERVICE_ROLE_SUCCESS = 'permissions/FETCH_SERVICE_ROLE_SUCCESS';
export const FETCH_SERVICE_ROLE_FAIL = 'permissions/FETCH_SERVICE_ROLE_FAIL';
export const CREATE_SERVICE_ROLE_SUCCESS = 'permissions/CREATE_SERVICE_ROLE_SUCCESS';
export const CREATE_SERVICE_ROLE_FAIL = 'permissions/CREATE_SERVICE_ROLE_FAIL';
export const DELETE_SERVICE_ROLE_SUCCESS = 'permissions/DELETE_SERVICE_ROLE_SUCCESS';
export const DELETE_SERVICE_ROLE_FAIL = 'permissions/DELETE_SERVICE_ROLE_FAIL';

export const FETCH_OPERATIONS_SUCCESS = 'permissions/FETCH_OPERATIONS_SUCCESS';
export const FETCH_OPERATIONS_FAIL = 'permissions/FETCH_OPERATIONS_FAIL';
export const CREATE_OPERATION_SUCCESS = 'permissions/CREATE_OPERATION_SUCCESS';
export const CREATE_OPERATION_FAIL = 'permissions/CREATE_OPERATION_FAIL';
export const UPDATE_OPERATION_SUCCESS = 'permissions/UPDATE_OPERATION_SUCCESS';
export const UPDATE_OPERATION_FAIL = 'permissions/UPDATE_OPERATION_FAIL';
export const DELETE_OPERATION_SUCCESS = 'permissions/DELETE_OPERATION_SUCCESS';
export const DELETE_OPERATION_FAIL = 'permissions/DELETE_OPERATION_FAIL';

export const RESET_PERMISSIONS = 'permissions/RESET_PERMISSIONS';
export const FETCH_PERMISSIONS = 'permissions/FETCH_PERMISSIONS';
export const FETCH_PERMISSIONS_FAIL = 'permissions/FETCH_PERMISSIONS_FAIL';
export const FETCH_PERMISSIONS_SUCCESS = 'permissions/FETCH_PERMISSIONS_SUCCESS';

export const FETCH_CUSTOMER_ROLES_SUCCESS = 'permissions/FETCH_CUSTOMER_ROLES_SUCCESS';
export const FETCH_CUSTOMER_ROLES_FAIL = 'permissions/FETCH_CUSTOMER_ROLES_FAIL';
export const CREATE_CUSTOMER_ROLES_SUCCESS = 'permissions/CREATE_CUSTOMER_ROLES_SUCCESS';
export const CREATE_CUSTOMER_ROLES_FAIL = 'permissions/CREATE_CUSTOMER_ROLES_FAIL';
export const DELETE_CUSTOMER_ROLES_SUCCESS = 'permissions/DELETE_CUSTOMER_ROLES_SUCCESS';
export const DELETE_CUSTOMER_ROLES_FAIL = 'permissions/DELETE_CUSTOMER_ROLES_FAIL';
export const CLEAR_CUSTOMER_ROLES_FAIL = 'permissions/CLEAR_CUSTOMER_ROLES_FAIL';
export const UPDATE_CUSTOMER_ROLES_REDUX = 'permissions/UPDATE_CUSTOMER_ROLES_REDUX';

export const FETCH_SERVICE_PARTNER_SUCCESS = 'permissions/FETCH_SERVICE_PARTNER_SUCCESS';
export const FETCH_SERVICE_PARTNER_FAIL = 'permissions/FETCH_SERVICE_PARTNER_FAIL';
export const CLEAR_SERVICE_PARTNER_SUCCESS = 'permissions/CLEAR_SERVICE_PARTNER_SUCCESS';
export const CREATE_SERVICE_PARTNER_SUCCESS = 'permissions/CREATE_SERVICE_PARTNER_SUCCESS';
export const CREATE_SERVICE_PARTNER_FAIL = 'permissions/CREATE_SERVICE_PARTNER_FAIL';
export const DELETE_SERVICE_PARTNER_SUCCESS = 'permissions/DELETE_SERVICE_PARTNER_SUCCESS';
export const DELETE_SERVICE_PARTNER_FAIL = 'permissions/DELETE_SERVICE_PARTNER_FAIL';

export const FETCH_SERVICE_USERS = 'permissions/FETCH_SERVICE_USERS';
export const FETCH_SERVICE_USERS_SUCCESS = 'permissions/FETCH_SERVICE_USERS_SUCCESS';
export const FETCH_SERVICE_USERS_FAIL = 'permissions/FETCH_SERVICE_USERS_FAIL';

export const FETCH_USER_ROLES = 'permissions/FETCH_USER_ROLES';
export const FETCH_USER_ROLES_SUCCESS = 'permissions/FETCH_USER_ROLES_SUCCESS';
export const FETCH_USER_ROLES_FAIL = 'permissions/FETCH_USER_ROLES_SUCCESS';
export const RESET_USER_ROLES = 'permissions/RESET_USER_ROLES';

export const FETCH_PARENT_ROLES_SUCCESS = 'permissions/FETCH_PARENT_ROLES_SUCCESS';
export const FETCH_PARENT_ROLES_FAIL = 'permissions/FETCH_PARENT_ROLES_FAIL';

export const FETCH_TEMPLATE_ROLES_SUCCESS = 'permissions/FETCH_TEMPLATE_ROLES_SUCCESS';
export const FETCH_TEMPLATE_ROLES_FAIL = 'permissions/FETCH_TEMPLATE_ROLES_FAIL';

export const FETCH_PERMISSIONS_BY_OPERATION_FAIL = 'permissions/FETCH_PERMISSIONS_BY_OPERATION_FAIL';
export const FETCH_PERMISSIONS_BY_OPERATION_SUCCESS = 'permissions/FETCH_PERMISSIONS_BY_OPERATION_SUCCESS';

// блок констант для управление Разрешениями партнёров (какими операциями они могут у себя управлять)
export const RESET_PARTNER_PERMISSIONS = 'permissions/RESET_PARTNER_PERMISSIONS';
export const FETCH_PARTNER_PERMISSIONS = 'permissions/FETCH_PARTNER_PERMISSIONS';
export const FETCH_PARTNER_PERMISSIONS_FAIL = 'permissions/FETCH_PARTNER_PERMISSIONS_FAIL';
export const FETCH_PARTNER_PERMISSIONS_SUCCESS = 'permissions/FETCH_PARTNER_PERMISSIONS_SUCCESS';
export const POST_PARTNER_PERMISSION_SUCCESS = 'permissions/POST_PARTNER_PERMISSION_SUCCESS';
export const POST_PARTNER_PERMISSION_FAIL = 'permissions/POST_PARTNER_PERMISSION_FAIL';
export const CLEAR_PARTNER_PERMISSION_LIST = 'permissions/CLEAR_PARTNER_PERMISSION_LIST';
